import styled from 'styled-components';
import { rem, rgba, cssVar } from 'polished';
import { prefix } from '../../tools/settings';
var Dropdown = styled.div.withConfig({
  displayName: "Dropdownstyles__Dropdown",
  componentId: "sc-29882t-0"
})(["position:relative;height:36px;padding:0 16px;align-items:center;display:inline-flex;border-radius:18px;background-color:var(--dentsu-color-white);&[aria-disabled='true']{pointer-events:none;opacity:0.4;}"]);
var DropdownContent = styled.div.withConfig({
  displayName: "Dropdownstyles__DropdownContent",
  componentId: "sc-29882t-1"
})(["position:relative;z-index:20;font-size:var(--dentsu-font-size-14);"]);
var DropdownContentLabel = styled.span.withConfig({
  displayName: "Dropdownstyles__DropdownContentLabel",
  componentId: "sc-29882t-2"
})(["color:var(--dentsu-color-n700);font-weight:var(--dentsu-font-weight-regular);margin-right:4px;"]);
var DropdownContentSelected = styled.span.withConfig({
  displayName: "Dropdownstyles__DropdownContentSelected",
  componentId: "sc-29882t-3"
})(["color:var(--dentsu-color-black);font-weight:var(--dentsu-font-weight-medium);"]);
var DropdownContentIcon = styled.span.attrs({
  className: "".concat(prefix, "-dropdown__content-icon")
}).withConfig({
  displayName: "Dropdownstyles__DropdownContentIcon",
  componentId: "sc-29882t-4"
})(["margin-left:4px;"]);
var DropdownSelect = styled.select.withConfig({
  displayName: "Dropdownstyles__DropdownSelect",
  componentId: "sc-29882t-5"
})(["position:absolute;cursor:pointer;left:0;top:0;z-index:30;width:100%;height:100%;appearance:none;opacity:0.001;&:focus ~ .dentsu-dropdown__backdrop:after{box-shadow:0 0 0 ", " ", ";}"], rem(4), rgba(cssVar('--dentsu-color-p150', '#cebaed'), 0.6));
var DropdownBackdrop = styled.div.attrs({
  className: "".concat(prefix, "-dropdown__backdrop")
}).withConfig({
  displayName: "Dropdownstyles__DropdownBackdrop",
  componentId: "sc-29882t-6"
})(["&:after{transition:all var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);transition-property:box-shadow;content:'';position:absolute;top:0;bottom:0;left:0;right:0;display:block;border-radius:18px;border:1px solid var(--dentsu-color-n300);background:var(--dentsu-color-white);}"]);
var DropdownOption = styled.option.withConfig({
  displayName: "Dropdownstyles__DropdownOption",
  componentId: "sc-29882t-7"
})([""]);
var DropdownOptionGroup = styled.optgroup.withConfig({
  displayName: "Dropdownstyles__DropdownOptionGroup",
  componentId: "sc-29882t-8"
})([""]);
export var Styled = {
  Dropdown: Dropdown,
  DropdownContent: DropdownContent,
  DropdownContentLabel: DropdownContentLabel,
  DropdownContentSelected: DropdownContentSelected,
  DropdownContentIcon: DropdownContentIcon,
  DropdownSelect: DropdownSelect,
  DropdownBackdrop: DropdownBackdrop,
  DropdownOption: DropdownOption,
  DropdownOptionGroup: DropdownOptionGroup
};